import { getCustomFieldList } from '@/api/sysManage/baseConfig/customFieldDisplayConfiguration'
import {
  CUSTOM_FIELD_1,
  CUSTOM_FIELD_2,
  CUSTOM_FIELD_3,
  CUSTOM_FIELD_4,
  CUSTOM_POSITION_1,
  CUSTOM_POSITION_2
} from '@/class/cargo/model/parameters/SystemConstants'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'

const CargoMsg_CN = require('@/lang/zh_CN/CargoMsg')
const CargoMsg_US = require('@/lang/en_US/CargoMsg')
const CargoMsg_JP = require('@/lang/ja_JP/CargoMsg')
const SeaExport_CN = require('@/lang/zh_CN/SeaExport')
const SeaExport_US = require('@/lang/en_US/SeaExport')
const SeaExport_JP = require('@/lang/ja_JP/SeaExport')

/**
 * 刷新自定义字段国际化值
 */
export async function refreshCustomField() {
  try {
    const res = await getCustomFieldList({ fieldDisplay: SystemConstants.FIELD_DISPLAY_BUSINESS_MODULE.code })
    updateFields(res.data.list)
  } catch (error) {
    console.error('Error fetching or updating fields:', error)
  }
}

function updateFields(list) {
  for (const item of list) {
    switch (item.fieldCode) {
      case CUSTOM_FIELD_1.code:
        SeaExport_CN.UserDefinedField1 = item.chineseName
        SeaExport_US.UserDefinedField1 = item.englishName
        SeaExport_JP.UserDefinedField1 = item.englishName
        break
      case CUSTOM_FIELD_2.code:
        SeaExport_CN.UserDefinedField2 = item.chineseName
        SeaExport_US.UserDefinedField2 = item.englishName
        SeaExport_JP.UserDefinedField2 = item.englishName
        break
      case CUSTOM_FIELD_3.code:
        SeaExport_CN.UserDefinedField3 = item.chineseName
        SeaExport_US.UserDefinedField3 = item.englishName
        SeaExport_JP.UserDefinedField3 = item.englishName
        break
      case CUSTOM_FIELD_4.code:
        SeaExport_CN.UserDefinedField4 = item.chineseName
        SeaExport_US.UserDefinedField4 = item.englishName
        SeaExport_JP.UserDefinedField4 = item.englishName
        break
      case CUSTOM_POSITION_1.code:
        CargoMsg_CN.Cargo_userDefinedRole1 = item.chineseName
        CargoMsg_US.Cargo_userDefinedRole1 = item.englishName
        CargoMsg_JP.Cargo_userDefinedRole1 = item.englishName
        break
      case CUSTOM_POSITION_2.code:
        CargoMsg_CN.Cargo_userDefinedRole2 = item.chineseName
        CargoMsg_US.Cargo_userDefinedRole2 = item.englishName
        CargoMsg_JP.Cargo_userDefinedRole2 = item.englishName
        break
      default:

        break
    }
  }
}
